import styled from '@emotion/styled'

import {
  DOCUMENT_HTML_PREVIEW_IFRAME_MAX_WIDTH,
  DOCUMENT_HTML_PREVIEW_IFRAME_MIN_WIDTH,
} from '../../constants/documentHtmlPreviewDimensions'

interface PreviewSkeletonBoxWrapperProps {
  zoom?: number
}

export const PreviewSkeletonBoxWrapper = styled.div<PreviewSkeletonBoxWrapperProps>`
  ${({ zoom }) => zoom !== undefined && `zoom: ${zoom};`}
`
export const FilesPreviewWrapper = styled.div`
  min-width: ${DOCUMENT_HTML_PREVIEW_IFRAME_MIN_WIDTH}px;
  max-width: ${DOCUMENT_HTML_PREVIEW_IFRAME_MAX_WIDTH}px;
  position: relative;
`
